<template>

    <nav class="navbar navbar-expand navbar-light topbar static-top shadow">

        <!-- Sidebar Toggle (Topbar) -->
        <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3" @click="sideNavToggle">
            <i class="fa fa-bars"></i>
        </button>

        <!-- Topbar Search -->
        <!-- <form class="d-none d-sm-inline-block form-inline ml-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
            <div class="input-group">
                <input type="text" class="form-control bg-light border-0 small" placeholder="جستجو ..."
                    aria-label="Search" aria-describedby="basic-addon2">
                <div class="input-group-append">
                    <button class="btn btn-primary" type="button">
                        <i class="fas fa-search fa-sm"></i>
                    </button>
                </div>
            </div>
        </form> -->
        <button id="sidebarToggleTop" class="btn btn-link d-md-block d-none rounded-circle mr-3" @click="sideNavToggle">
            <i class="fa-solid fa-bars-staggered"></i>
        </button>

        <!-- Topbar Navbar -->
        <ul class="navbar-nav mr-auto">

            <!-- Nav Item - Search Dropdown (Visible Only XS) -->
            <li class="nav-item dropdown no-arrow d-sm-none">
                <!-- <a class="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-search fa-fw"></i>
                </a> -->
                <!-- Dropdown - Messages -->
                <div class="dropdown-menu dropdown-menu-left p-3 shadow animated--grow-in"
                    aria-labelledby="searchDropdown">
                    <form class="form-inline mr-auto w-100 navbar-search">
                        <div class="input-group">
                            <input type="text" class="form-control bg-light border-0 small" placeholder="Search for..."
                                aria-label="Search" aria-describedby="basic-addon2">
                            <div class="input-group-append">
                                <button class="btn btn-sm btn-primary" type="button">
                                    <i class="fa-solid fa-magnifying-glass fa-sm"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </li>
            <PersianClock />

            <!-- Nav Item - Alerts -->
            <li class="nav-item dropdown no-arrow mx-1">
                <a class="nav-link dropdown-toggle badge-bell" href="#" id="alertsDropdown" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-bell fa-bellanimation fa-fw" v-if="Notifications.length > 0"></i>
                    <i class="fas fa-bell fa-fw" v-if="Notifications.length == 0"></i>
                    <!-- Counter - Alerts -->
                    <span v-if="Notifications.length > 0" class="badge badge-danger badge-counter">{{
                        Notifications.length }}</span>
                </a>
                <!-- Dropdown - Alerts -->
                <div class="dropdown-list dropdown-menu dropdown-menu-left shadow animated--grow-in"
                    aria-labelledby="alertsDropdown">
                    <h6 class="dropdown-header">
                        اعلان ها
                    </h6>
                    <div v-for="item in Notifications" :key="item"
                        class="dropdown-item d-flex align-items-center Notification-link"
                        @click="OpenNotification(item)">
                        <!-- <div :style="{backgroundColor:item.color,height:'50px',width:'5px'}"></div> -->
                        <div class="Notification-block" :style="{ borderColor: item.color }">

                            <div class="small text-gray-500">{{ item.dateCreated }}</div>
                            <span class="font-weight-bold">{{ item.text.split("*")[2] }}</span>
                        </div>
                    </div>
                    <a v-if="Notifications.length == 0" class="dropdown-item d-flex align-items-center" href="#">
                        اعلان جدیدی وجود ندارد
                    </a>



                    <!-- <a class="dropdown-item text-center small text-gray-500" href="#">مشاهده همه اعلان ها</a> -->
                </div>
            </li>



            <div class="topbar-divider d-none d-sm-block"></div>

            <!-- Nav Item - User Information -->
            <li class="nav-item dropdown no-arrow">
                <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <span class="ml-2 d-none d-lg-inline text-gray-600 small">{{ userName }}</span>
                    <img class="img-profile rounded-circle" src="/images/avator.jpg">
                </a>
                <!-- Dropdown - User Information -->
                <div class="dropdown-menu dropdown-menu-left shadow animated--grow-in" aria-labelledby="userDropdown">

                    <!-- <button class="dropdown-item  border-none" @click="openChangeBackground">

                        <i class="fa-solid fa-gears fa-fw mr-2 text-gray-400"></i>
                        تصویر زمینه
                    </button> -->
                    <button class="dropdown-item" to="dashboard" @click="SignOut()">
                        <span class="fa fa-power-off"></span>
                        خروج
                    </button>

                </div>
            </li>

        </ul>

    </nav>
    <audio id="BellSound" src="/sounds/bell.mp3" type="audio/mp3" class="d-none">

    </audio>
</template>
<script>
// import axios from "axios";
// import { Loading } from "../../public/js/Utilities";

import axios from 'axios';
// import ChangeBackground from '../../components/panel/ChangeBackground.vue';
// import { openModal } from "jenesius-vue-modal";
export default {

    data() {
        return {
            mobile: window.innerWidth <= 767,
            userName: "",
            Notifications: [],
        }
    },
    mounted() {
        this.LoadNotifications();
        this.userName = localStorage.getItem("userName");
        if (this.mobile == true) {
            document.getElementById("page-top").classList.add("sidebar-toggled");
            if (document.getElementById("accordionSidebar")) {
                document.getElementById("accordionSidebar").classList.add("toggled");
            }
        }
    },
    methods: {
        OpenNotification(item) {

            axios.post("/Notification/Seened?Id=" + item.id);
            this.Notifications = this.Notifications.filter(c => c.id != item.id);
            this.$router.push('/CrmUser=' + item.text.split('*')[1]);
        },
        sideNavToggle() {

            if (document.getElementById("page-top").classList.contains("sidebar-toggled")) {
                document.getElementById("page-top").classList.remove("sidebar-toggled");
            }
            else {
                document.getElementById("page-top").classList.add("sidebar-toggled");
            }
            if (document.getElementById("accordionSidebar").classList.contains("toggled")) {
                document.getElementById("accordionSidebar").classList.remove("toggled");
            }
            else {
                document.getElementById("accordionSidebar").classList.add("toggled");
            }
        },
        // openChangeBackground() {
        //     openModal(ChangeBackground)
        // },
        PlaySound() {

            var sound = document.getElementById('BellSound');
            sound.play();
        },
        LoadNotifications() {
            axios.get("/Notification/GetShortList").then((res) => {
                if (res.data.value != null) {
                    this.Notifications = res.data.value;
                    if (this.Notifications.length > 0) {
                        this.PlaySound();
                    }
                }
            });
        },
        SignOut() {
            localStorage.clear();
            window.location.href = "/";
        },
    }

}
</script>
<style scoped>
/* Don't forget to include the animation time for the start block */
.fade-enter-active,
.fade-leave-active,
.fade-enter-active .modal-item,
.fade-leave-active .modal-item {
    transition: 1.0s;
}

.fade-enter-from .modal-item,
.fade-leave-to .modal-item {
    transform: scale(0);
}

.fade-enter-from,
.fade-leave-to {
    background-color: transparent;
}

.badge-bell {
    font-size: 20px;
}

.badge-bell .badge-counter {
    margin-top: -10px !important;
}

.Notification-link {
    background-color: white;

    padding-right: 5px;
    padding-left: 5px;

}

.Notification-block {

    border-right: 0;
    border-bottom: 0px !important;
    border-top: 0px !important;
    border-left: 0px !important;
    border-radius: 0 5px 5px 0;
    border-width: 4px;
    border-style: solid;
    padding-right: 4px;

}

.Notification-block span {
    font-size: 12px;
    color: #383838 !important;
    font-weight: 600 !important;
}

.fa-bellanimation {

    animation: ring 5s infinite ease-in-out;
}

.fa-bell {
    display: inline-block;

}

/* انیمیشن زنگ */
@keyframes ring {

    0%,
    90%,
    100% {
        transform: rotate(0) scale(1);
        color: #666;
    }

    91% {
        transform: rotate(15deg) scale(1.2);
        color: #ff9800;
    }

    92% {
        transform: rotate(-12deg) scale(1.2);
        color: #ff5722;
    }

    93% {
        transform: rotate(10deg) scale(1.2);
        color: #f44336;
    }

    94% {
        transform: rotate(-8deg) scale(1.1);
        color: #ff5722;
    }

    95% {
        transform: rotate(6deg) scale(1.1);
        color: #ff9800;
    }

    96% {
        transform: rotate(-4deg) scale(1.05);
        color: #ffb300;
    }

    97% {
        transform: rotate(2deg) scale(1.05);
        color: #ff9800;
    }

    98% {
        transform: rotate(-1deg) scale(1.02);
        color: #ffb300;
    }

    99% {
        transform: rotate(0) scale(1);
        color: #666;
    }
}
</style>